import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ProjectCard.css';

export default function ProjectCard({ project, index = 0 }) {
    const navigate = useNavigate();
    const cardRef  = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Stagger by index
                        setTimeout(() => {
                            entry.target.classList.add('card-visible');
                        }, (index % 4) * 80);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.08 }
        );
        if (cardRef.current) observer.observe(cardRef.current);
        return () => observer.disconnect();
    }, [index]);

    const handleClick = () => navigate(`/projects/${project.id}`);

    // Status colour map
    const statusColor = {
        'completed':   'var(--cyan)',
        'in-progress': 'var(--spark)',
        'in progress': 'var(--spark)',
        'planned':     'var(--violet)',
    }[project.status?.toLowerCase()] || 'var(--dim)';

    return (
        <div
            ref={cardRef}
            className="pc-card"
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && handleClick()}
        >
            {/* Thumbnail */}
            <div className="pc-thumb">
                {project.thumbnail ? (
                    <img
                        src={project.thumbnail}
                        alt={project.title}
                        loading="lazy"
                        onError={e => { e.target.style.display = 'none'; }}
                    />
                ) : (
                    <div className="pc-thumb-placeholder">
                        <span>{project.title?.[0] ?? '?'}</span>
                    </div>
                )}
                <div className="pc-thumb-overlay" />

                {/* Status badge */}
                {project.status && (
                    <div className="pc-status-badge" style={{ '--sc': statusColor }}>
                        <span className="pc-status-dot" />
                        {project.status}
                    </div>
                )}
            </div>

            {/* Body */}
            <div className="pc-body">
                {project.category && (
                    <p className="pc-category">{project.category}</p>
                )}
                <h2 className="pc-title">{project.title}</h2>
                <p className="pc-desc">{project.description}</p>

                <div className="pc-footer">
                    <span className="pc-cta">View Project →</span>
                    {project.date_created && (
                        <span className="pc-date">
                            {new Date(project.date_created).getFullYear()}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}